import React from 'react';

import { Box } from '@mui/material';

import { InboxItemContentVerificationRequestCreateCommentForm } from 'src/components/inboxItem';

import { RequestContent } from './components';

export const VerificationRequestConsumer: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <RequestContent />
      <InboxItemContentVerificationRequestCreateCommentForm />
    </Box>
  );
};
